import { render, staticRenderFns } from "./Developening.vue?vue&type=template&id=66b1dc66&scoped=true&"
import script from "./Developening.vue?vue&type=script&lang=js&"
export * from "./Developening.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b1dc66",
  null
  
)

export default component.exports